export default "__VITE_ASSET__oyE6WwhG__"